// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const isInactiveTab = () => document.hidden;

// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
export const isBlurredDocument = () => !document.hasFocus();
